import { render, staticRenderFns } from "./AssinanteEditTabAssinatura.vue?vue&type=template&id=2903b560&"
import script from "./AssinanteEditTabAssinatura.vue?vue&type=script&lang=js&"
export * from "./AssinanteEditTabAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports